<template>
  <div id="submission">
    <h1 class="mt-4" style="margin-bottom: 40px">Submission</h1>
    <b-container>
       <b-form class="text-left" style="margin-bottom: 20px; text-align: right">
        <b-input-group size="" class="mb-2">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input type="search" v-model="filter" placeholder="Search Submission"></b-form-input>
        </b-input-group>
      </b-form>
      <b-table :fields="fields" :items="items" hover outlined :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :filter="filter">
        <template #cell(view)="data">
          <!--
          <b-button size="sm" variant="primary" :href="`#/problem/${data.item.id}`">{{ data.value }}</b-button>
          -->
          <b-button size="sm" variant="primary" @click="toSubmission(data.item.id)"
            >View</b-button
          >
        </template>
      </b-table>
    </b-container>
  </div>
</template>
<script>
export default {
  created() {
    const api = "/judge/result";
    const token = localStorage.getItem("access_token");
    this.$http
      .get(api, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        //console.log("resp: ", response.data)
        for (let i in response.data) {
          response.data[i].created_date = response.data[i].created_date.replace(/T/, " ").split('.')[0];
        }
        
        this.items = response.data;
      });
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "problem_id",
          label: "Problem ID",
          sortable: false,
        },
        {
          key: "created_date",
          label: "Submission Date",
        },
        {
          key: "username",
          label: "User Name"
          
        },
        {
          key: "view",
        },
      ],
      items: [],
      sortBy: "id",
      sortDesc: true,
      filter: ""
    };
  },
  methods: {
    toSubmission(id) {
      this.$router.push({ path: "/submission/" + id });
    },
  },
};
</script>

<style>
tr {
  vertical-align: middle;
}
</style>